export const environment = {
  endpoint: 'https://admin-stage.revista-liber.org',
  assetsEndpoint: 'https://arteycultura.s3.amazonaws.com',
  title: 'Revista Liber',
  production: true,
  sonicRadioPort: '8344',
};
